var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.732812 1.28112C0.266145 1.74779 0.266145 2.44779 0.732812 2.91445L4.81615 6.99779L0.732812 11.0811C0.266146 11.5478 0.266146 12.2478 0.732812 12.7145C1.19948 13.1811 1.89948 13.1811 2.36615 12.7145L7.26615 7.81445C7.49948 7.58112 7.61615 7.34779 7.61615 6.99779C7.61615 6.64779 7.49948 6.41445 7.26615 6.18112L2.36615 1.28112C1.89948 0.814453 1.19948 0.814453 0.732812 1.28112Z",
    fill: "#252525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.1c4f1daf3aa1237d7b00ba2881fb1bc8.svg";
export { ForwardRef as ReactComponent };